// Module
var code = "<tasks-filter group=$ctrl.group></tasks-filter> <tasks-list group=$ctrl.group></tasks-list> ";
// Exports
module.exports = code;